import * as React from 'react';
import { deepEquals } from 'app/infrastructure/js';

import type { JSX } from "react";

interface TranslationComponentProps {
  translation: any;
}

interface TranslationComponentState {
  translation: any;
}

export const withCachedTranslation = <T extends TranslationComponentProps>(component: any) => {
  const Component = component;
  type TranslationProps = T & TranslationComponentProps;
  class TranslationComponent extends React.Component<TranslationProps, TranslationComponentState> {
    constructor(props: TranslationProps) {
      super(props);
      this.state = {
        translation: props.translation
      };
    }

    public static getDerivedStateFromProps(nextProps: TranslationProps, prevState: TranslationComponentState) {
      if (!deepEquals(nextProps.translation, prevState.translation)) {
        return {
          translation: nextProps.translation
        };
      }
      return null;
    }

    public render(): JSX.Element {
      return <Component {...this.props} translation={this.state.translation} />;
    }
  }
  return TranslationComponent;
};
